import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/lib/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { MainFacade } from '../main.facade';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  profileToggle:any="missions";
  user:any;
  currentLevel:any="";
  code:any;

  public user$: Observable<any>|undefined;
  public nfts$: Observable<any>|undefined;
  public myMissions$: Observable<any>|undefined;
  public levels$: Observable<any>|undefined;
  public pass$: Observable<any>|undefined;
  private destroy$ = new Subject();
  constructor(private mainfacade:MainFacade, private auth: AuthService) { }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setObservables() {
    this.nfts$ = this.mainfacade.nfts$
    this.user$ = this.mainfacade.user$;
    this.myMissions$ = this.mainfacade.myMissions$;
    this.pass$ = this.mainfacade.pass$;
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 

      if(message){
        this.user = message;
        this.code=sessionStorage.getItem('code');
        if(this.code) {
          sessionStorage.removeItem('code');
          this.mainfacade.discordAuth(this.code, this.user.Id)
        }
        this.currentLevel = message.UserSkills.find((val)=>{
          return val.SkillName === 'Gang Level';
        })
        
        //this.wallet = this.user.Wallet.slice(0, 4) + "..." + this.user.Wallet.slice(41, 44);
 

        //this.burnWallet =  this.user.Wallets[0];
      }

    });


    this.levels$ = this.mainfacade.levels$;
    /*this.levels$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        let levelFound = false;
        message.forEach(element => {
          if(Number(this.user.ExpBalance) >= Number(element.Exp)){
            this.currentLevel = element.LevelName;
          }
          
        });

        
      }

    });*/

  }

  

  AuthenticateDiscord(){
    this.auth.discordAuth();
    
  }

  refreshPage(){

    sessionStorage.removeItem('code');
    sessionStorage.removeItem('state');
    window.location.href = environment.prod+'/#/profile';
   
  }

}
